import store from './stores'

export default (to, from, next) => {
  const isLogin = to.fullPath.includes('/login')

  // check for requiredAuth
  if (to.matched.some(record => record.meta.auth)) {
    // Check if NOT logged in
    if (!store.getters.isLoggedIn) {
      // Go to login page

      // next({
      //   path: '/login',
      //   query: {
      //     redirect: to.fullPath
      //   }
      // });
    } else {
      next();
    }
  } else {
    if (isLogin && store.getters.isLoggedIn) {
      next({ path: '/' });
    }else {
      next();
    }
  }
};
